export default function closePopup(state) {
	const popupArray = state.popups;
	popupArray.pop();
	return { ...state, popups: popupArray };
}
